import { onAuthStateChanged } from "firebase/auth";
import { createContext, useEffect, useState } from "react";
import { auth } from "../firebase/Config";

export const AuthContext = createContext(null)

function Context({ children }) {
    const [user, setUser] = useState()

    useEffect(() => {
        //current user
        onAuthStateChanged(auth, (user) => {
          setUser(user)
        })
      }, [])
      
    return (
            <AuthContext.Provider value={{ user, setUser }}>
                {children}
            </AuthContext.Provider>
    )
}

export default Context